/* global angular, analytics_data */
import { analyticsEvent } from "../../controllers/analytics-controller";

var SortBySelectController = function (
  $scope,
  $location,
  $timeout,
  $http,
  searchService,
  savedSearchService
) {
  "use strict";

  var vm = this;
  var setSelectOption = function () {
    $scope.selectedOption =
    vm.sortbyval !== "relevance" && vm.searchtype === "content"
      ? vm.sortbyval + "-" + vm.sortorder
      : "relevance";
  }
  vm.sorter = $scope.$parent.sorter;
  vm.themeOmdia = angular.element(document.body).hasClass("theme-omdia");
  vm.searchtype = searchService.getSearchType() || "content";
  vm.sortbyval = searchService.getSortByValue() || "relevance";
  vm.sortorder = searchService.getCurrentSortOrder() || "desc";

  setSelectOption();

  vm.update = function () {
    var search_utility = "";
    switch ($scope.selectedOption) {
      case "date-desc":
        vm.sorter.setByWithOrder("date", "desc");
        search_utility = "sort_by_date:desc";
        break;
      case "date-asc":
        vm.sorter.setByWithOrder("date", "asc");
        search_utility = "sort_by_date:asc";
        break;
      case "relevance":
        vm.sorter.setByWithOrder("relevance", "desc");
        search_utility = "sort_by_relevance";
        break;
    }
    analyticsEvent(
      $.extend(analytics_data, {
        event_name: "search_utility",
        search_utility: search_utility,
      })
    );
  };

  $scope.$watch(
    function () {
      return searchService.getSearchType();
    },
    function () {
      vm.searchtype = searchService.getSearchType() || "content";
      setSelectOption();
    }
  );
  
  $scope.$watch(
    function () {
      return searchService.getSortByValue();
    },
    function () {
      vm.sortbyval = searchService.getSortByValue() || "relevance";
      setSelectOption();
    }
  );
  
  $scope.$watch(
    function () {
      return searchService.getCurrentSortOrder();
    },
    function () {
      vm.sortorder = searchService.getCurrentSortOrder() || "desc";
      setSelectOption();
    }
  );
};

var informaSearchApp = angular.module("informaSearchApp");
informaSearchApp.controller("SortBySelectController", [
  "$scope",
  "$location",
  "$timeout",
  "$http",
  "searchService",
  "savedSearchService",
  SortBySelectController,
]);
